import classNames from 'classnames';
import camelize from 'dom-helpers/camelize';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const pascalCase = str => str[0].toUpperCase() + camelize(str).slice(1);

// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
export default function createWithBsPrefix(prefix) {
  let {
    displayName = pascalCase(prefix),
    Component,
    defaultProps
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const BsComponent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      className,
      bsPrefix,
      as: Tag = Component || 'div',
      ...props
    } = _ref;
    const resolvedPrefix = useBootstrapPrefix(bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Tag, {
      ref: ref,
      className: classNames(className, resolvedPrefix),
      ...props
    });
  });
  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}